import { makeAutoObservable } from 'mobx';
import Scooter from './Scooter';

class Zone {

  id = null;
  name = null;
  coordinates = [];
  kind = 'point';
  radius = 50;
  address = null;
  phone = null;
  openFrom = 11;
  openTo = 20;
  photos = [];
  scooters = [];
  scootersCount = null;

  constructor(raw) {
    this.id = raw.id;
    this.name = raw.name;
    this.coordinates = raw.coordinates;
    this.kind = raw.kind;
    this.radius = raw.radius;
    this.address = raw.address;
    this.phone = raw.phone;
    this.openFrom = raw.open_from;
    this.openTo = raw.openTo;
    this.photos = raw.photos;
    this.scooters = raw.scooters?.map(scooter => new Scooter(scooter));
    this.scootersCount = raw.scooters_count ?? null;

    makeAutoObservable(this);
  }

}


export default Zone;
